// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c8431860","732":"5f75d941","977":"f1bb0b1f"}[chunkId] + ".chunk.js";
};